import api from './api'

export const serbaUsahaService = {
  // Barang
  getBarang: (params = {}) => api.get('/serba-usaha/barang', { params }),
  createBarang: (data) => api.post('/serba-usaha/barang', data),
  updateBarang: (kode, data) => api.put(`/serba-usaha/barang/${kode}`, data),
  deleteBarang: (kode) => api.delete(`/serba-usaha/barang/${kode}`),

  // Stok Masuk
  createStokMasuk: (data) => api.post('/serba-usaha/stok-masuk', data),
  getStokMasuk: (params = {}) => api.get('/serba-usaha/stok-masuk', { params }),

  // Transaksi
  createTransaksi: (data) => api.post('/serba-usaha/transaksi', data),
  getTransaksi: (params = {}) => api.get('/serba-usaha/transaksi', { params }),
  getTransaksiDetail: (no) => api.get(`/serba-usaha/transaksi/${no}`),

  // Pembayaran
  bayarAngsuran: (no, data) => api.post(`/serba-usaha/transaksi/${no}/bayar`, data),
  getTagihan: (params = {}) => api.get('/serba-usaha/tagihan', { params }),

  // Laporan
  getLaporanPenjualan: (params = {}) => api.get('/serba-usaha/laporan/penjualan', { params }),
  getLaporanLaba: (params = {}) => api.get('/serba-usaha/laporan/laba', { params }),
  getLaporanPiutang: (params = {}) => api.get('/serba-usaha/laporan/piutang', { params }),

  // Settings
  getSettings: () => api.get('/serba-usaha/settings'),
  updateSettings: (data) => api.put('/serba-usaha/settings', data),
}
